import { createStore, applyMiddleware, compose } from 'redux';
// middleware
import thunkMiddleware from 'redux-thunk';
//import promiseMiddleware from 'redux-promise' // TODO promise middleware
import { createLogger } from 'redux-logger';

//import reduxImmutableStateInvariant from 'redux-immutable-state-invariant'

const ENABLE_IMMUTABLE_TEST = false;

let createStoreWithMiddleware: Function;

declare var __DEV__: boolean;

if (typeof __DEV__ !== 'undefined' && __DEV__) {
    // const persistState = require('redux-devtools').persistState;

    const middleware = [];
    // TODO move to .env exist(react.redux.immutable)
    if (ENABLE_IMMUTABLE_TEST) {
        middleware.push(
            // reduxImmutableStateInvariant({
            //     ignore: ["form"] // TODO move to .env react.redux.immutable.ignore;
            // })
        );
    }

    middleware.push(thunkMiddleware);
    //middleware.push(promiseMiddleware);

    // Logger middleware
    middleware.push(
        createLogger({
            level: 'info', // TODO .env react.redux.logger.level || 'info'
            collapsed: true, // TODO .env react.redux.logger.collapsed || true
        }),
    );

    //const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
//, persistState(window.location.href.match(/[?&]debug_session=([^&]+)\b/)) // TODO Chceme persist state ?
    createStoreWithMiddleware = (((compose(applyMiddleware(...middleware))(createStore)) as any as Function)); // TODO use composeEnhancers

} else {
    createStoreWithMiddleware = compose(
        applyMiddleware(thunkMiddleware), // TODO promiseMiddleware
    )(createStore);
}

export default createStoreWithMiddleware;
